/**
 * Сегмент где, если у цены копейки равны '00' заменяются на пустую строку
 */
export const hasPricesWithoutZeroPenny = window.app && window.app.hasPricesWithoutZeroPenny
